import { useRecoilValue } from 'recoil';
import * as atoms from '../atoms';
import { isInSaaSMode } from '../utils/common';

const useSelectedEnv = () => {
  const isInSaaS = isInSaaSMode();
  const selectedEnvId = useRecoilValue(atoms.selectedEnvironmentId);
  return isInSaaS ? selectedEnvId : undefined;
};

export default useSelectedEnv;
